const MVCObject = require("../mvcobject").MVCObject;
const directions = require("../maps/directions");

/**
 *
 * @extends woosmap.utils.MVCObject
 * @memberOf woosmap.location
 */
class DirectionsProvider extends MVCObject {
    /**
     * Constructs a new DirectionsProvider
     * @constructor
     * @param {google.maps.DirectionsRendererOptions} [directionRendererOptions] options for Google Maps. Deprecated since 1.2 Set options into {DirectionsResultsDisplayer} instead.
     * @param {google.maps.DirectionsRequest} [googleDirectionsRequestOptions] options for Google Maps.
     * @param {function} [directionsRequestErrorCallback] callback call if directions request status is not OK.
     * The callback arguments are response (the google response) and status
     * ( [StatusCodes](https://developers.google.com/maps/documentation/directions/?csw=1#StatusCodes) ).
     */
    constructor(directionRendererOptions, googleDirectionsRequestOptions, directionsRequestErrorCallback) {
        super();
        this._googleDirectionsService = null;
        this.directionRendererOptions = directionRendererOptions;
        this.googleDirectionsRequestOptions = googleDirectionsRequestOptions;
        this.directionsRequestErrorCallback = directionsRequestErrorCallback;
        /**
         * This property is observable
         * An array containing information about each route
         * @type {Array.<DirectionsRouteInformationsParams>}
         */
        this.directionsSummaries = [];
        /**
         * This property is observable
         * An array containing renderer about each route
         * @type {Array.<google.maps.DirectionsRenderer>}
         */
        this.directionsRenderers = [];
        /**
         * This property is observable
         * A link to open google map with the current itinerary
         * @type {String}
         */
        this.directionsLink = null;
        /**
         * This property is observable
         * @type {String}
         */
        this.selectedTravelMode = null;
        /**
         * This property is observable
         * @type {LatLngLiteral}
         */
        this.originDestination = null;

        /**
         *
         * @type {DirectionsInterface|*}
         * @private
         */
        this._directionsImplementation = directions.getDirectionsImplementation(this);
    }

    /**
     * Triggered when originDestination attribute changed (observer)
     */
    originDestination_changed() {
        this.getDirectionsFromOrToStore();
    }

    /**
     * Triggered when selectedTravelMode attribute changed (observer)
     */
    selectedTravelMode_changed() {
        if (this.get("originDestination")) {
            this.getDirectionsFromOrToStore();
        }
    }

    /**
     * Trigger setMap and setPanel with null parameter for each renderer to remove their polyline and panel details
     */
    cleanMapFromRoutes() {
        if (this.get("directionsRenderers")) {
            this.get("directionsRenderers").forEach((renderer) => {
                renderer.setMap(null);
                renderer.setPanel(null);
            });
        }
    }

    /**
     *
     * @param {Number} rendererIndex
     * @returns {string}
     */
    getRouteEncodedPolyline(rendererIndex) {
        const directionsRenderers = this.get("directionsRenderers");
        if (directionsRenderers?.[rendererIndex]) {
            return directionsRenderers[rendererIndex].directions.routes[0].overview_polyline;
        }
    }

    /**
     * Get directions from, or to, store with google directions services and set results in directionsRenderers
     */
    getDirectionsFromOrToStore() {
        return this._directionsImplementation.getDirectionsFromOrToStore();
    }

    /**
     *
     * @param {Object} requestParams
     * @param {Function} successCallback
     * @param {Function} failCallback
     * @returns {*}
     */
    route(requestParams, successCallback, failCallback) {
        return this._directionsImplementation.route(requestParams, successCallback, failCallback);
    }

    /**
     * Set directionsRenderers and directionsSummary objects
     * @param {google.maps.DirectionsResult} response a google direction result which contain all path and info
     */
    setDirectionsObjectsWithResponse(response) {
        return this._directionsImplementation.setDirectionsObjectsWithResponse(response);
    }

    /**
     * Get the direct link to google or baidu directions from the user's input
     * @param {woosmap.maps.utils.LatLng|null} origin route origin
     * @param {woosmap.maps.utils.LatLng|null} destination route destination
     * @param {string|null} travelMode travelMode for Baidu if needed
     */
    getDirectionsLink(origin = null, destination = null, travelMode = null) {
        return this._directionsImplementation.getDirectionsLink(origin, destination, travelMode);
    }

    /**
     * Gets available travel modes.
     * @returns {*}
     */
    getAvailableTravelModes() {
        return this._directionsImplementation.getAvailableTravelModes();
    }
}

exports.DirectionsProvider = DirectionsProvider;
